import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import store from '@/store';
import uaParser from 'ua-parser-js'
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;
import {
  getTourists
} from '@/api/drop'
//重写VueRouter.prototype身上的push方法了
VueRouter.prototype.push = function(location, resolve, reject) {
  if (resolve && reject) {
   
    originPush.call(this, location, resolve, reject);
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
//重写VueRouter.prototype身上replace的方法了
VueRouter.prototype.replace = function(location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    );
  }
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    meta:{
      title:'Login - CoDropshipping'
    },
    component: () => import("../views/login/Login.vue"),
  },
  {
    path: "/signUp",
    name: "signUp",
    meta:{
      title:'SignUp - CoDropshipping'
    },
    component: () => import("../views/login/SignUp.vue"),
  },
  {
    path: "/signUpGoogle",
    name: "signUpGoogle",
    meta:{
      title:'SignUp With Google - CoDropshipping'
    },
    component: () => import("../views/login/SignUpGoogle.vue"),
  },
  {
    path: "/verifyEmail",
    name: "verifyEmail",
    meta:{
      title:'Verify Email - CoDropshipping'
    },
    component: () => import("../views/login/VerifyEmail.vue"),
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    meta:{
      title:'Forgot Password - CoDropshipping'
    },
    component: () => import("../views/login/ForgotPassword.vue"),
  },
  {
    path: "/sendToEmail",
    name: "sendToEmail",
    meta:{
      title:'Send to Email - CoDropshipping'
    },
    component: () => import("../views/login/SendToEmail.vue"),
  },
  {
    path: "/resetPassword",
    name: "resetPassword",
    meta:{
      title:'Reset Password - CoDropshipping'
    },
    component: () => import("../views/login/ResetPassword.vue"),
  },
  {
    path: "/introduction",
    name: "introduction",
    meta:{
      title:'introduction - CoDropshipping'
    },
    component: () => import("../views/introduction/index.vue"),
  },
  {
    path: "/loginCode",
    name: "loginCode",
    meta:{
      title:'CoDropshipping'
    },
    component: () => import("../views/login/loginCode.vue"),
  },
  {
    path: "/",
    component: HomeView,
    redirect: "/home",
    meta:{
      title:'CoDropshipping',
    },
    children:[
      {
        path: "/home",
        name: "home",
        meta:{
          title:'Home - CoDropshipping'
        },
        component: () => import("../views/home/HomeNew.vue"),
      },
      {
        path: "/dropshipping",
        name: "dropshipping",
        meta:{
          title:'USA Dropshipping - CoDropshipping'
        },
        component: () => import("../views/home/Dropshipping.vue"),
      },
      {
        path: "/dropshippingMX",
        name: "dropshippingMX",
        meta:{
          title:'Mexico Dropshipping - CoDropshipping'
        },
        component: () => import("../views/home/DropshippingMX.vue"),
      },
      {
        path: "/allcategories",
        name: "allcategories",
        meta:{
          title:'All Categories - CoDropshipping',
        },
        component: () => import("../views/home/Categories_new.vue"),
      },
      {
        path: "/categories",
        name: "categories",
        meta:{
          title:'All categories - CoDropshipping'
        },
        component: () => import("../views/home/categories.vue"),
      },
      {
        path: "/category",
        name: "category",
        meta:{
          title:'All categories - CoDropshipping'
        },
        component: () => import("../views/category/index.vue"),
      },
      {
        path: "/homeNew",
        name: "homeNew",
        meta:{
          title:'Home - CoDropshipping'
        },
        component: () => import("../views/home/HomeNew.vue"),
      },
      {
        path: "/search",
        name: "search",
        meta:{
          title:'Search - CoDropshipping'
        },
        component: () => import("../views/productList/search.vue"),
      },
      {
        path: "/account",
        name: "account",
        meta:{
          title:'My account - CoDropshipping'
        },
        component: () => import("../views/account/Account.vue"),
      },
      {
        path: "/cart",
        name: "cart",
        meta:{
          title:'My Cart - CoDropshipping'
        },
        component: () => import("../views/cart/Cart_new.vue"),
      },
      {
        path: "/chat",
        name: "chat",
        meta:{
          title:'Chat - CoDropshipping'
        },
        component: () => import("../views/gpt/index.vue"),
      },
      {
        path: "/main/tracking",
        name: "tracking",
        meta:{
          title:'Tracking - CoDropshipping'
        },
        component: () => import("../views/track/Tracking.vue"),
      },
      {
        path: "/track/trackingDetail",
        name: "trackingDetail",
        meta:{
          title:'Tracking Detail - CoDropshipping'
        },
        component: () => import("../views/track/TrackDetails.vue"),
      },
      {
        path: "/parcelPrice",
        name: "parcelPrice",
        meta:{
          title:'Parcel Price - CoDropshipping'
        },
        component: () => import("../views/account/ParcelPrice.vue"),
      },
      {
        path: "/authorization",
        name: "authorization",
        meta:{
          title:'Store Authorization - CoDropshipping'
        },
        component: () => import("../views/account/Authorization.vue"),
      },
      {
        path: "/order",
        name: "orderInfo",
        meta:{
          title:'Order Info - CoDropshipping'
        },
        component: () => import("../views/account/order/create_new.vue"),
      },
      {
        path: "/main/paymentResult",
        name: "orderPaymentResult",
        meta:{
          title:'Payment Result - CoDropshipping'
        },
        component: () => import("../views/account/order/success.vue"),
      },
      {
        path: "/main/orderDetails",
        name: "orderDetails",
        meta:{
          title:'Order Details - CoDropshipping'
        },
        component: () => import("../views/account/order/details.vue"),
      },
      {
        path: "/main/inventory",
        name: "inventory",
        meta:{
          title:'Inventory Details - CoDropshipping'
        },
        component: () => import("../views/account/order/inventory.vue"),
      },
      {
        path: "/main/outbound",
        name: "outbound",
        meta:{
          title:'Package Information - CoDropshipping'
        },
        component: () => import("../views/account/order/outbound.vue"),
      },
      {
        path: "/productDetail",
        name: "productDetail",
        meta:{
          title:'Product - CoDropshipping'
        },
        component: () => import("../views/productDetail/index_new.vue"),
      },
      {
        path: "/main/request",
        name: "request",
        meta:{
          title:'Request a Quote - CoDropshipping'
        },
        component: () => import("../views/account/order/Request.vue"),
      },
    ]
  },
  {
    path: "/main/orderList",
    name: "orderList",
    meta:{
      title:'Order List - CoDropshipping'
    },
    component: () => import("../views/account/order/list_new.vue"),
  },
  {
    path: "/main/InboundManagement",
    name: "InboundManagement",
    meta:{
      title:'Inbound Management - CoDropshipping'
    },
    component: () => import("../views/warehouse/InboundManagement.vue"),
  },
  {
    path: "/warehouse/ApplySpace",
    name: "ApplySpace",
    meta:{
      title:'Apply For Storage Space - CoDropshipping'
    },
    component: () => import("../views/warehouse/ApplySpace.vue"),
  },
  {
    path: "/orderPayment",
    name: "orderPayment",
    meta:{
      title:'Order Payment - CoDropshipping'
    },
    component: () => import("../views/account/order/payment.vue"),
  },
  {
    path: "/ShopifyVerify",
    name: "ShopifyVerify",
    meta:{
      title:'Shopify Verify - CoDropshipping'
    },
    component: () => import("../views/account/ShopifyVerify.vue"),
  },
  {
    path: "/ShopifyVerifyResult",
    name: "ShopifyVerifyResult",
    meta:{
      title:'Shopify Verify Result - CoDropshipping'
    },
    component: () => import("../views/account/ShopifyVerifyResult.vue"),
  },
  {
    path: "/myProduct",
    name: "myProduct",
    meta:{
      title:'My Product - CoDropshipping'
    },
    component: () => import("../views/my-product/index.vue"),
  },
  {
    path: "/pushProduct",
    name: "pushProduct",
    meta:{
      title:'Push Product - CoDropshipping'
    },
    component: () => import("../views/my-product/push-product.vue"),
  },
  {
    path: "/storeProduct",
    name: "storeProduct",
    meta:{
      title:'Store Product - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/store/store-product.vue"),
  },
  {
    path: "/storeLogistics",
    name: "storeLogistics",
    meta:{
      title:'Store Logistics - CoDropshipping',
    },
    component: () => import("../views/store/set-logistics.vue"),
  },
  {
    path: "/storeOrder",
    name: "storeOrder",
    meta:{
      title:'Store Order - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/store/store-order.vue"),
  },
  {
    path: "/payConfirm",
    name: "payConfirm",
    meta:{
      title:'Pay Confirm - CoDropshipping',
    },
    component: () => import("../views/store/pay-confirm.vue"),
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    meta:{
      title:'Store Detail - CoDropshipping',
    },
    component: () => import("../views/store/order-detail.vue"),
  },
  {
    path: "/payStoreOrder",
    name: "payStoreOrder",
    meta:{
      title:'Pay Order - CoDropshipping',
    },
    component: () => import("../views/store/pay-page.vue"),
  },
  // {
  //   path: "/order",
  //   name: "orderInfo",
  //   meta:{
  //     title:'Order Info - CoDropshipping'
  //   },
  //   component: () => import("../views/account/order/create.vue"),
  // },
  {
    path: "/productList",
    name: "productList",
    meta:{
      title:'Product - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/product.vue"),
  },
  {
    path: "/productLists",
    name: "productLists",
    meta:{
      title:'Product - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/productAli.vue"),
  },
  {
    path: "/freeShipping",
    name: "freeShipping",
    meta:{
      title:'Free Shipping - Cargosoon',
      keepAlive: true
    },
    component: () => import("../views/productList/freeShipping.vue"),
  },
  {
    path: "/oneItem",
    name: "oneItem",
    meta:{
      title:'One item - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/oneItem.vue"),
  },
  {
    path: "/specialArea",
    name: "specialArea",
    meta:{
      title:'Special Area - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/specialArea.vue"),
  },
  {
    path: "/specialAreas",
    name: "specialAreas",
    meta:{
      title:'Special Area - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/aliArea.vue"),
  },
  {
    path: "/rankList",
    name: "rankList",
    meta:{
      title:'rankList - CoDropshipping',
      keepAlive: true
    },
    component: () => import("../views/productList/rankList.vue"),
  },
  {
    path: "/main/member",
    name: "member",
    meta:{
      title:'My Member - CoDropshipping'
    },
    component: () => import("../views/account/Member.vue"),
  },
  {
    path: "/main/memberReview",
    name: "memberReview",
    meta:{
      title:'Member Review - CoDropshipping'
    },
    component: () => import("../views/account/MemberReview.vue"),
  },
  {
    path: "/main/wallet",
    name: "wallet",
    meta:{
      title:'My Wallet - CoDropshipping'
    },
    component: () => import("../views/account/Wallet.vue"),
  },
  {
    path: "/main/WalletTopUp",
    name: "WalletTopUp",
    meta:{
      title:'Wallet TopUp - CoDropshipping'
    },
    component: () => import("../views/account/WalletTopUp.vue"),
  },
  {
    path: "/main/TopUpResult",
    name: "TopUpResult",
    meta:{
      title:'Wallet TopUp - CoDropshipping'
    },
    component: () => import("../views/account/TopUpResult.vue"),
  },
  {
    path: "/main/PayResult",
    name: "PayResult",
    meta:{
      title:'Wallet TopUp - CoDropshipping'
    },
    component: () => import("../views/account/TopUpResult.vue"),
  },
  {
    path: "/main/walletDetail",
    name: "walletDetail",
    meta:{
      title:'My Wallet - CoDropshipping'
    },
    component: () => import("../views/account/WalletDetail.vue"),
  },
  {
    path: "/main/setting",
    name: "setting",
    meta:{
      title:'Setting - CoDropshipping'
    },
    component: () => import("../views/account/Setting.vue"),
  },
  {
    path: "/main/profile",
    name: "profile",
    meta:{
      title:'Profile - CoDropshipping'
    },
    component: () => import("../views/account/Profile.vue"),
  },
      {
        path: "/main/changePassword",
        name: "changePassword",
        meta:{
          title:'ChangePassword - CoDropshipping'
        },
        component: () => import("../views/account/ChangePassword.vue"),
      },
      {
        path: "/lottery",
        name: "lottery",
        meta:{
          title:'lottery - CoDropshipping'
        },
        component: () => import("../views/actions/Lottery.vue"),
      },
      {
        path: "/rules",
        name: "rules",
        meta:{
          title:'Lottery rules - CoDropshipping'
        },
        component: () => import("../views/actions/Rules.vue"),
      },
      {
        path: "/gains",
        name: "gains",
        meta:{
          title:'My gains - CoDropshipping'
        },
        component: () => import("../views/actions/MyGains.vue"),
      },
  {
    path: "/main/address",
    name: "address",
    meta:{
      title:'Address - CoDropshipping'
    },
    component: () => import("../views/account/Address.vue"),
  },
  {
    path: "/main/addAddress",
    name: "addAddress",
    meta:{
      title:'Add Address - CoDropshipping'
    },
    component: () => import("../views/account/AddAddress.vue"),
  },
  {
    path: "/main/FBAwarehouse",
    name: "FBAwarehouse",
    meta:{
      title:'FBA Warehouse Address - CoDropshipping'
    },
    component: () => import("../views/account/FBAwarehouse.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to,from,next)=>{
  to.meta.previousRoute = from.path;
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
});
router.beforeEach((to,from,next)=>{
  let token = store.state.user.token
  if(token){
    if(to.path.indexOf('/booking')!=-1){
      next({path:'/'})
    }else{
      next()
    }
  }else{
    if(!window.localStorage.getItem("Touriststoken")){
      const ua = uaParser(navigator.userAgent)
      // const ua = uap.getResult()
      let ruleForm = {}
      ruleForm.browser = ua.browser.name
      ruleForm.sys = ua.os.name + ua.os.version
      ruleForm.agent = ua.ua
      ruleForm.machine = window.screen.width + '*' + window.screen.height
      ruleForm.language = window.navigator.language
      getTourists(ruleForm).then((req)=>{
        window.localStorage.setItem('Touriststoken', req.data.token)
      })
    }
    
    if(to.query.ref){
      localStorage.setItem("invitation_codes", to.query.ref)
    }
    
    if(to.path.indexOf('/main')!=-1 || to.path.indexOf('/order')!=-1){
      next({path:'/login'})
    }else if(to.path.indexOf('/booking')!=-1){
      next({path:'/'})
    }else{
      next()
    }
  }
})
export default router;
